// extracted by mini-css-extract-plugin
module.exports = {"loadMessage":"loader_loadMessage__AbefB","text":"loader_text__4QOAd"};